module.exports = __webpack_public_path__ + "static/media/download-iphone.6c2e9aeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bebanca/download-iphone.jpg
// module id = 970
// module chunks = 0